import messages from '../locales/et_EE.json';

const lang = {
    messages: {
        ...messages,
    },
    locale: 'et-EE',
};
export default lang;
